import { UnknowErrorException } from '@/domain/common/exceptions';

export const registerNonClientExecute = async (
  payload,
  registerNonClientService
) => {
  const request = {
    documentType: payload.documentType,
    document: payload.document,
    fathersLastName: payload.fathersName,
    mothersLastName: payload.mothersName,
    name: payload.firstName,
    mail: payload.email,
    phone: payload.cellPhone,
  };
  const {
    responseCode,
    status,
    message,
    data: dataNonClient,
  } = await registerNonClientService(request);
  if (status === 200 && responseCode === '00') {
    let platformName = '';
    if (dataNonClient[0].platformName) {
      platformName = 'NA';
    }
    return {
      responseCode,
      dataNonClient: { ...dataNonClient[0], platformName },
    };
  } else {
    throw new UnknowErrorException({
      errorCode: responseCode,
      message,
    });
  }
};
